// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var _a, _b;
// How two lifecycle configurations compare (design §5b), for the
// configuration approval's diff: each policy or rule change is a tightening,
// a loosening, or both. How a save applies comes from the server.
import { EInitializationScope, EUnsignedScheduledClosePolicy, } from "@sequentech/ui-core";
export var EPolicyChange;
(function (EPolicyChange) {
    EPolicyChange["NONE"] = "none";
    /** Requires more: applies now. */
    EPolicyChange["TIGHTENS"] = "tightens";
    /** Requires less: applies after the next approved publication. */
    EPolicyChange["LOOSENS"] = "loosens";
    /** Requires something new and drops something else: both rules apply until then. */
    EPolicyChange["MIXED"] = "mixed";
})(EPolicyChange || (EPolicyChange = {}));
/** What each initialization scope requires before a Post opens. */
var SCOPE_REQUIRES = (_a = {},
    _a[EInitializationScope.POST] = ["post"],
    _a[EInitializationScope.EVENT] = ["post", "every-post"],
    _a[EInitializationScope.POST_AND_COUNTRY] = ["post", "every-country"],
    _a);
/** What each close policy requires of a scheduled close outside the signed configuration. */
var CLOSE_REQUIRES = (_b = {},
    _b[EUnsignedScheduledClosePolicy.REFUSE] = ["signatures"],
    _b[EUnsignedScheduledClosePolicy.RUN_AS_SYSTEM] = [],
    _b);
/** Compares two sets of requirements. */
export var requirementChange = function (before, after) {
    var added = after.some(function (requirement) { return !before.includes(requirement); });
    var dropped = before.some(function (requirement) { return !after.includes(requirement); });
    if (added && dropped)
        return EPolicyChange.MIXED;
    if (added)
        return EPolicyChange.TIGHTENS;
    if (dropped)
        return EPolicyChange.LOOSENS;
    return EPolicyChange.NONE;
};
/** The policies with their defaults (design §2: `None` = defaults). */
export var policiesOf = function (policies) {
    var _a, _b;
    return ({
        initialization_scope: (_a = policies === null || policies === void 0 ? void 0 : policies.initialization_scope) !== null && _a !== void 0 ? _a : EInitializationScope.POST,
        unsigned_scheduled_close: (_b = policies === null || policies === void 0 ? void 0 : policies.unsigned_scheduled_close) !== null && _b !== void 0 ? _b : EUnsignedScheduledClosePolicy.REFUSE,
    });
};
export var scopeChange = function (before, after) {
    return requirementChange(SCOPE_REQUIRES[before], SCOPE_REQUIRES[after]);
};
export var closePolicyChange = function (before, after) { return requirementChange(CLOSE_REQUIRES[before], CLOSE_REQUIRES[after]); };
/** How a signing rule edit applies: requiring signatures, or more of them, tightens. */
export var ruleChange = function (before, after) {
    var _a, _b;
    if (before.required !== after.required) {
        return after.required ? EPolicyChange.TIGHTENS : EPolicyChange.LOOSENS;
    }
    if (!after.required)
        return EPolicyChange.NONE;
    var from = (_a = before.signatures) !== null && _a !== void 0 ? _a : 0;
    var to = (_b = after.signatures) !== null && _b !== void 0 ? _b : 0;
    if (to > from)
        return EPolicyChange.TIGHTENS;
    if (to < from)
        return EPolicyChange.LOOSENS;
    return EPolicyChange.NONE;
};
